import React from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

/**
 * Wrapper that applies a subtle fade-in animation on route changes.
 * Uses CSS animation tied to a key prop that changes with the route.
 */
const PageTransition = ({ children }) => {
  const location = useLocation();

  return (
    <Box
      key={location.pathname}
      className="page-fade-enter"
      sx={{ width: '100%' }}
    >
      {children}
    </Box>
  );
};

export default PageTransition;
